export const OrganizationLeftList = [
  {
    name: 'Offers',
    alt: 'Offers',
    src: 'icons/navBar/approval',
    text: 'Предложения по КЦП',
    roles: ['ORGANIZATION_ROLE']
  },
  {
    name: 'License',
    alt: 'License',
    src: 'icons/navBar/license_info',
    text: 'Сведения о лицензиях',
    roles: ['ORGANIZATION_ROLE']
  },
  {
    name: 'Accreditation',
    alt: 'Accreditation',
    src: 'icons/navBar/accreditation',
    text: 'Аккредитации организации',
    roles: ['ORGANIZATION_ROLE']
  },
  {
    name: 'FormList',
    alt: 'FormList',
    src: 'icons/navBar/materials',
    text: 'Формы',
    roles: ['ORGANIZATION_ROLE']
  },
  {
    name: 'BlockPrintOrganization',
    alt: 'BlockPrintOrganization',
    src: 'icons/navBar/convertBlock',
    text: 'Блокировка и отправка заявки',
    roles: ['ORGANIZATION_ROLE']
  },
  {
    name: 'AllList',
    alt: 'AllList',
    src: 'icons/navBar/instructions',
    text: 'Сводные оценки заявок',
    roles: ['ORGANIZATION_ROLE']
  },
  {
    name: 'AllListStage1',
    alt: 'AllListStage1',
    src: 'icons/navBar/graphs',
    text: 'Распределение КЦП',
    roles: ['ORGANIZATION_ROLE']
  },
  {
    name: 'AllListStage1CorrectValues',
    alt: 'AllListStage1CorrectValues',
    src: 'icons/navBar/license_info',
    text: 'Согласование дополнительных объемов КЦП',
    roles: ['ORGANIZATION_ROLE']
  },
]

export const FounderLeftList = [
  {
    path: '/accreditation-agreed',
    name: '',
    alt: 'Accreditation_agreed',
    src: 'icons/navBar/accreditation_approval',
    text: 'Одобрение аккредитаций',
    roles: ['CO_ROLE', 'FOUNDER_ROLE']
  },
  {
    path: '/accreditation-agreed-sign',
    name: '',
    alt: 'Accreditation_agreed_sign',
    src: 'icons/navBar/accreditation_approval',
    text: 'Подписание заявки по аккредитациям',
    roles: ['CO_ROLE', 'FOUNDER_ROLE']
  },
  {
    name: 'instructions',
    alt: 'Инструкция',
    src: 'icons/navBar/instructions',
    text: 'Инструкция',
    functionName: 'downloadInstruction',
    roles: ['REGION_ROLE', 'CO_ROLE', 'FOUNDER_ROLE', 'ORGANIZATION_ROLE'],
  },
]

export const LeftListFixed = [
  {
    name: 'stage-2',
    alt: 'Этап 2',
    src: 'icons/navBar/approval',
    text: 'Согласование общих объемов КЦП на 2025/26 учебный год',
    roles: ['REGION_ROLE'],
  },
  {
    name: 'AllListRegion',
    hoverName: 'AllListRegion',
    alt: 'AllListRegion',
    src: 'icons/navBar/graphs',
    text: 'Объемы КЦП в регионе на 2025/26 учебный год',
    roles: ['REGION_ROLE'],
  },
  {
    name: 'stage-3',
    alt: 'Этап 3',
    src: 'icons/navBar/approval',
    text: 'Согласование общих объемов КЦП на 2025/26 учебный год',
    roles: ['CO_ROLE'],
  },
  { // для минкульта
    name: 'approval-regions',
    alt: 'Согласование с регионами',
    src: 'icons/navBar/accreditation',
    text: 'Согласование с регионами',
    roles: ['CO_ROLE'],
  },
  { // для минкульта
    name: 'approval-regions-alt',
    alt: 'Согласование проекта КЦП Субъектов РФ',
    src: 'icons/navBar/accreditation',
    text: 'Согласование проекта КЦП Субъектов РФ',
    roles: ['CO_ROLE', 'FOUNDER_ROLE'],
  },
  // {
  //   path: '/methods',
  //   name: '',
  //   alt: 'Методические материалы',
  //   src: 'icons/navBar/materials',
  //   text: 'Методические материалы',
  //   roles: ['REGION_ROLE', 'CO_ROLE', 'FOUNDER_ROLE'],
  // },
  {
    name: 'instructions',
    alt: 'Инструкция',
    src: 'icons/navBar/instructions',
    text: 'Инструкция',
    functionName: 'downloadInstruction',
    roles: ['REGION_ROLE', 'CO_ROLE', 'FOUNDER_ROLE', 'ORGANIZATION_ROLE'],
  },
  {
    name: 'contacts_co',
    alt: 'Контакты центров ответственности',
    src: 'icons/navBar/contacts_CO',
    text: 'Контакты центров ответственности',
    roles: ['REGION_ROLE', 'CO_ROLE'],
  },
  {
    name: 'contacts_regions',
    alt: 'Контакты представителей субъектов РФ',
    src: 'icons/navBar/contacts_region',
    text: 'Контакты представителей субъектов РФ',
    roles: ['REGION_ROLE', 'CO_ROLE', 'FOUNDER_ROLE'],
  },
];